import { render } from "./SocialLoginForm.vue?vue&type=template&id=60ad21c0"
import script from "./SocialLoginForm.vue?vue&type=script&lang=js"
export * from "./SocialLoginForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__